import { Box, Typography } from '@mui/material';

export const PageNumber = ({ pageNumber }: { pageNumber: string }) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        bottom: '5px',
        right: '10px',
        zIndex: 999999,
        pointerEvents: 'none',
      }}
    >
      <Typography variant="body1" fontSize="1rem">
        {pageNumber}
      </Typography>
    </Box>
  );
};
